module.exports = __webpack_public_path__ + "static/logo-0644211941c823c1e408d8110ee652a4.svg";